import React from "react";
import useQuery from "../useQuery";
import { useQueryClient } from "@tanstack/react-query";
import { useChannel } from "../ws/useChannel";
import { mapFormulaVersionStartsAtToDate } from "../../domain/formula-version";

const PATH = "/projects/:projectId(uuid)/quantities/formulas/versions" as const;

export function useFormulaVersions(projectId: string) {
  const queryClient = useQueryClient();
  const invalidate = React.useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: ["GET", PATH, { projectId }],
    });
  }, [projectId, queryClient]);

  useChannel({ key: "formula_versions", projectId }, invalidate, false);

  const formulaVersions = useQuery(PATH, {
    routeParams: { projectId },
  }).body;

  return React.useMemo(() => mapFormulaVersionStartsAtToDate(formulaVersions), [formulaVersions]);
}
export type FormulaVersion = ReturnType<typeof useFormulaVersions>[number];

export function useQuantityFormulaVersions(projectId: string, quantityId: string) {
  const formulaVersions = useFormulaVersions(projectId);

  return React.useMemo(
    () => formulaVersions.filter(formulaVersion => formulaVersion.quantityId === quantityId),
    [formulaVersions, quantityId],
  );
}
